import ConfirmButton from "@/components/Button/ConfirmButton";
import MoreVert from "@mui/icons-material/MoreVert";
import { Box, Divider, IconButton, Menu, MenuItem, MenuList, Typography } from "@mui/material";
import { useState } from "react";

export default function SegmentManageButton({ segment, onClickEditSegment, onClickDeleteSegment }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <Box>
            <IconButton onClick={handleClick}>
                <MoreVert />
            </IconButton>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ minWidth: 500 }}>
                <MenuItem onClick={onClickEditSegment}>Edit</MenuItem>
                <Divider />
                <ConfirmButton
                    component={MenuItem}
                    sx={{ color: "red" }}
                    onClick={onClickDeleteSegment}
                    dialogTitle="ยืนยัน"
                    dialogContent={
                        <>
                            <Typography gutterBottom>ต้องการลบ data segment</Typography>
                            <Typography gutterBottom color="red">
                                {segment.title}
                                <Typography component="span" color="text.primary">
                                    ใช่หรือไม่
                                </Typography>
                            </Typography>
                            <Typography color="text.secondary">note: ข้อมูลจะถูกลบออกจากฐานข้อมูลทั้งหมด</Typography>
                        </>
                    }
                    confirmButtonProps={{ color: "error" }}
                >
                    Delete
                </ConfirmButton>
            </Menu>
        </Box>
    );
}
